import styled from 'styled-components';

export const CompanyFeatures = styled.div`
  background: var(--primary-subtle);
  border-radius: var(--radius-md);
  padding: 16px 20px;
  margin-bottom: 22px;

  ul {
    list-style: none;

    li {
      font-size: var(--text-sm);
      color: var(--text-secondary);
      padding: 4px 0 4px 24px;
      position: relative;

      &::before {
        content: '✓';
        position: absolute;
        left: 0;
        color: var(--primary);
        font-weight: 700;
      }
    }
  }
`;
